import {
  LegalClientSourcesOfIncomeFinancialSourceType,
  LegalClientSourcesOfIncomeSourceType,
} from 'api/types/entity';
import { LegalClientSaveSourcesOfIncomeParam } from 'api/types/params';

import { SourcesOfIncomeFormType } from '../../forms/sourcesOfIncomeForm';

export const getSubmitData = (
  values: SourcesOfIncomeFormType
): LegalClientSaveSourcesOfIncomeParam => {
  const financialSources = values.financialSources.map((v) => v.value);
  const incomeSources = values.incomeSources.map((v) => v.value);
  return {
    fileIds: values.fileIds,
    financialSources,
    incomeSources,
    otherFinancialSource: financialSources.includes(
      LegalClientSourcesOfIncomeFinancialSourceType.Other
    )
      ? values.otherFinancialSource
      : undefined,

    otherIncomeSource: incomeSources.includes(
      LegalClientSourcesOfIncomeSourceType.Other
    )
      ? values.otherIncomeSource
      : undefined,
  };
};
